module.exports = __webpack_public_path__ + "static/Firewatch2-c690eb337db26890730e049352d98142.webp";